import { z } from 'zod';
import { objectIdSchema } from './common.js';
/**
 * Журнал аудита. CLAUDE.md, правило 4: каждая запись содержит хеш предыдущей.
 * Любая правка в БД задним числом рвёт цепочку, и это видно при проверке.
 */
export const auditActionSchema = z.enum([
    'auth.login',
    'auth.login_failed',
    'auth.logout',
    'auth.refresh_reuse_detected',
    'auth.device_bound',
    'auth.mfa_enabled',
    'user.invited',
    'user.activated',
    'user.suspended',
    'user.role_granted',
    'role.created',
    'role.updated',
    'role.deleted',
    'org.created',
    'org.settings_updated',
    'site.created',
    'site.updated',
    'unit.created',
    'unit.updated',
    'unit.qr_rotated',
    'unit.driver_assigned',
    'template.published',
    'threshold.updated',
    'inspection.submitted',
    'inspection.rejected',
    'defect.opened',
    'defect.acknowledged',
    'defect.assigned',
    'defect.repaired',
    'defect.closed',
    'schedule.created',
    'inspection.missed',
    'inspection.miss_explained',
    'policy.published',
    'policy.acknowledged',
    'evidence.exported',
    'legal_hold.placed',
    'legal_hold.released',
    'retention.configured',
    'retention.purge_planned',
    'retention.purged',
    'support.impersonated',
]);
export const auditEntrySchema = z.object({
    id: objectIdSchema,
    orgId: objectIdSchema,
    seq: z.number().int().nonnegative(),
    prevHash: z.string(),
    hash: z.string(),
    action: auditActionSchema,
    actorUserId: objectIdSchema.nullable(),
    actorRoleKey: z.string().nullable(),
    target: z.object({ kind: z.string(), id: z.string().nullable() }).nullable(),
    /** Дифф изменений — для правки ролей это само по себе доказательство. */
    diff: z.unknown().nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    at: z.coerce.date(),
});
export const auditQuerySchema = z.object({
    action: auditActionSchema.optional(),
    actorUserId: objectIdSchema.optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
export const chainVerificationSchema = z.object({
    ok: z.boolean(),
    checked: z.number().int(),
    brokenAtSeq: z.number().int().nullable(),
});
//# sourceMappingURL=audit.js.map